import * as React from "react";
import styled from "styled-components";
import InputField from "@ingka/input-field";
import Modal, { ModalBody, Sheets } from "@ingka/modal";
import Toast from "@ingka/toast";
import Button from "@ingka/button";
import { SrOnly, StyledModalHeader } from "../../styles";

const StyledButton = styled(Button)`
	margin-top: 1rem;
	max-width: 50%;
	left: 25%;
	margin-bottom: 4%;
`;

interface ModalLayoutProps {
	showModal: boolean;
	setShowModal: (value: boolean) => void;
	toastMessage: string;
	setToastMessage: (value: string) => void;
	declineAppId: string;
	reason: string;
	loading: boolean;
	setReason: (value: string) => void;
	declineApp: (declineAppId: string, reason: string) => void;
}

const Layout: React.FC<ModalLayoutProps> = ({
	showModal,
	setShowModal,
	toastMessage,
	setToastMessage,
	declineAppId,
	reason,
	setReason,
	loading,
	declineApp,
}) => {
	return (
		<>
			<Modal visible={showModal} handleCloseBtn={() => setShowModal(false)} onModalClosed={() => {}}>
				<Sheets
					aria-labelledby="declineAppReqModalTitleId"
					footer={
						<StyledButton
							text="Decline"
							type="emphasised"
							loading={loading}
							onClick={() => {
								declineApp(declineAppId, reason);
							}}
						/>
					}
					header={<StyledModalHeader title="Decline Application Request" titleId="declineAppReqModalTitleId" />}
				>
					<ModalBody>
						<InputField disabled={true} value={declineAppId} id="appId" label="App Id" type="text" />
						<InputField
							req={true}
							value={reason}
							id="reason"
							label="Reason"
							type="text"
							onChange={(e) => {
								setReason(e.target.value);
							}}
						/>
					</ModalBody>
				</Sheets>
			</Modal>
			<SrOnly role="status" aria-live="polite" aria-atomic="true">
				{toastMessage}
			</SrOnly>
			<Toast
				text={toastMessage}
				isOpen={!!toastMessage}
				ariaLabelCloseBtn="Dismiss notification"
				onCloseRequest={() => setToastMessage("")}
			/>
		</>
	);
};

export default Layout;
